import { httpCreate } from './http';

const http = httpCreate('/srv/activity');

export const activity = {
	//子账号管理直播间列表
	activityForAuth(params) {
		return http.get('/activityForAuth', {
			params,
		});
	},
	selfMchInfo(activityId) {
		return http.get(`/selfMchInfo/${activityId}`);
	},
	// 获取上传token

	uploadToken(id, params) {
		return http.get(`/${id}/uploadToken`, { params });
	},
	activityList(params) {
		return http.get('', { params });
	},
	updateParticipantsConfig(data, activityId) {
		return http.post(`/updateParticipantsConfig/${activityId}`, data);
	},
	participantsType(activityId, participantsType) {
		return http.put(`/participantsType/${activityId}/${participantsType}`);
	},
	getParticipantsConfig(activityId, activityTitle) {
		return http.get(`/participantsConfig/${activityId}`, activityTitle);
	},
	//热门 顺序
	hotPdatePriority(data, type) {
		return http.post(`/updatePriority/${type}`, data);
	},
	getTestNum() {
		return http.get('/getTestNum');
	},
	getIsHot(params = {}) {
		params.isCache = 0;
		return http.get('/getIsHot', { params });
	},
	getIsRecent(params = {}) {
		params.isCache = 0;
		return http.get('/getIsRecent', { params });
	},
	setIsRecent(id, status) {
		const params = { status };
		return http.post(`/setIsRecent/${id}`, {}, { params });
	},
	setIsHot(id, status) {
		const params = { status };
		return http.post(`/setIsHot/${id}`, {}, { params });
	},
	setIsSlideshow(id, status, data) {
		const params = { status };
		return http.post(`/setIsSlideshow/${id}`, data, { params });
	},
	createActivity(data) {
		return http.post('', data);
	},
	updateActivity(id, data) {
		return http.put(`/${id}`, data);
	},
	getLiveShareInfo(id, params) {
		return http.get(`/customShare/${id}`, { params });
	},
	updateCustomShare(data) {
		return http.post('/updateCustomShare', data);
	},
	addCustomShare(data) {
		return http.post('/addCustomShare', data);
	},
	//升级直播间
	upgrade(id, type) {
		const params = { type };
		return http.post(`/upgrade/${id}`, {}, { params });
	},
	getActivityById(id) {
		return http.get(`/${id}`);
	},
	getActivityPwdById(id) {
		return http.get(`/${id}/pwd`);
	},
	getActivityStatistics(id) {
		return http.get(`/${id}/statistics`);
	},
	//新获取地图省份访问数量
	getActivityProvince(id) {
		return http.get(`/${id}/province`);
	},
	//地图省份前十排名
	getProvincePercent(id, params) {
		return http.get(`/${id}/province/percent`, { params });
	},
	//省份城市明细
	getPercentIntro(id, provinceId) {
		return http.get(`/${id}/city/${provinceId}`);
	},
	//城市排名前十
	getCity(id, params) {
		return http.get(`/${id}/city`, { params });
	},
	delActivityById(id, params) {
		return http.delete(`/${id}`, { params });
	},
	getAllType() {
		return http.get('/getAllType');
	},
	openActivity(id) {
		return http.get(`/open/${id}`);
	},
	closeActivity(id) {
		return http.get(`/close/${id}`);
	},
	addLike(id) {
		return http.get(`/addLike/${id}`);
	},
	payattention(id) {
		return http.get(`/${id}/attention`);
	},
	delattention(id) {
		return http.delete(`/${id}/attention`);
	},
	writeData(id, data) {
		return http.post(`/${id}/updateStatistics`, data);
	},
	changeActivityPower(id, isImpower) {
		return http.post(`/activity/${id}/updateImpower/${isImpower}`);
	},
	uploadConfig(id) {
		return http.get(`/${id}/uploadConfig`);
	},
	userWaterHistory(id) {
		return http.get(`/${id}/waterMarkHistory`);
	},
	postWaterHistory(id, data) {
		return http.post(`${id}/waterMarkHistory`, data);
	},
	//复制直播
	copyLives(activityId, data) {
		return http.post(`${activityId}/copy`, data);
	},
	// 试用直播
	getTrialActivity(data) {
		return http.get(`/getTrialActivity?isPay=${data}`);
	},
	getLineChartList(activityId, params) {
		return http.get(`getLineChart/${activityId}`, { params });
	},
	//获取当前在线人数图表数据
	getLineChartListOnline(activityId, params) {
		return http.get(`online/chart/${activityId}`, { params });
	},
	// 大屏互动设置信息
	getScreenInfo(activityId) {
		return http.get(`getScreenInfo/${activityId}`);
	},
	// 获取签到列表
	getSignList(activityId, params) {
		return http.get(`/sign/list/${activityId}`, { params });
	},
	setScreenPassword(activityId) {
		return http.post(`/setScreenPassword/${activityId}`);
	},
	// 删除签到列表
	deleteSignList(ids) {
		return http.delete('/sign/delete', { data: ids });
	},
	//获取邀请榜榜单
	getInviteList(activityId, params) {
		return http.get(`/getInviteList/pc/${activityId}`, { params });
	},
	//清空邀请榜单
	clearInviteList(activityId) {
		return http.delete(`/inviteList/${activityId}`);
	},
	//直播间收益
	getFund(activityId) {
		return http.get(`/getFund/${activityId}`);
	},
	//收益折线图
	getFundChart(activityId, params) {
		return http.get(`/getFundChart/${activityId}`, { params });
	},
	//性别饼状图
	sexParticipants(activityId) {
		return http.get(`/sexParticipants/${activityId}`);
	},
	//观看终端饼状图
	platformParticipants(activityId) {
		return http.get(`/platformParticipants/${activityId}`);
	},
	// 复制直播间
	copy(acitivityId, data) {
		return http.post(`/${acitivityId}/copy`, data);
	},
	// 活动标题列表
	titleList(userId) {
		return http.get(`/titleList/${userId}`);
	},
	// 根据标题获取直播间列表
	getTitleActivityList(userId, params) {
		return http.get(`/titleList/${userId}`, { params });
	},
	onlineLimit(activityId) {
		return http.get(`/online-limit/${activityId}`);
	},
	// 视频合集/锦集列表
	getActivityByUserId(companyUserId, params) {
		return http.get(`/getActivityByUserId/${companyUserId}`, { params });
	},
	// 获取要关联的直播间信息
	getActivityRelationInfo(activityId) {
		return http.get(`/isOwner/${activityId}`);
	},
	// 获取当前在线人数，单位 00:00
	getOnlineHourChart(activityId, params) {
		return http.get(`/online/hourChart/${activityId}`, { params });
	},
	// 获取当前实时访问量 单位 00:00
	getLineHourChart(activityId, params) {
		return http.get(`/getLineHourChart/${activityId}`, { params });
	},
	// 获取直播间数据
	getActivityStat(params) {
		return http.get('/activityStat', { params });
	},
	// 获取直播间是否绑定商户
	getActivityHaveSelfMch(activityId, params) {
		return http.get(`/haveSelfMch/${activityId}`, { params });
	},
	// 获取用户是否绑定商户
	getUserHaveSelfMch() {
		return http.get('/haveSelfMch');
	},
	// 获取用户是否绑定商户 ==> 通过合集归属人判断是否开启
	getUserHaveTrueSelfMch(userId) {
		return http.get(`/user/haveSelfMch/${userId}`);
	},
	// 是否具有绑定的第三方公众号
	getAuthorizerAppid(activityId, params) {
		return http.get(`/getAuthorizerAppid/${activityId}`, { params });
	},
	getActivityInfoById(activityId) {
		return http.get(`/${activityId}`);
	},
	// 直播间是否为单场
	getActivitySingleStatus(acitivityId, params) {
		return http.get(`/consume-times/${acitivityId}`, { params });
	},
	recover(activityId) {
		return http.post(`/recover/${activityId}`);
	},
};
